const DISCOUNT_ITEMS = [
  { label: 'Below 10%', end: 10 },
  { label: '10% and Above', start: 10 },
  { label: '20% and Above', start: 20 },
  { label: '30% and Above', start: 30 },
  { label: '40% and Above', start: 40 }
];

export default DISCOUNT_ITEMS;
